import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {useFetchEffect} from 'hooks/useFetchEffect'
import {useSelector} from 'hooks/redux'
import {ProcedureStatus} from 'types/api/procedureStatuses/procedureStatus'
import {FlatCard, FlatCardHeader, FlatCardTitle, FlatCardBody, FlatCardListItem} from '../FlatCard'
import {SeeMoreButton} from '../SeeMoreButton'
import styles from './MyProcedureStatuses.scss'

// @ts-ignore
import {actionCreators} from 'actions'
// @ts-ignore
import api from 'api'
// @ts-ignore
import DateOn from 'components/DateOn'
// @ts-ignore
import {statusDisplay} from 'procedureStatuses/ListNotAdmin'
// @ts-ignore
import {titleMap} from 'procedureStatuses/Show'

const MAX_COUNT = 5

interface ProcedureStatusItemProps {
  procedureStatus: ProcedureStatus
}

const ProcedureStatusItem: FC<ProcedureStatusItemProps> = ({procedureStatus}) => {
  const children = (
    <>
      <div className={styles.title}>{titleMap[procedureStatus.procedure_type]}</div>
      <div className={styles.meta}>
        <div className={styles.tag}>
          <span>{statusDisplay(procedureStatus.status, procedureStatus.application_status)}</span>
        </div>
        <div>
          <DateOn date={procedureStatus.date_on} />
        </div>
      </div>
    </>
  )

  return procedureStatus.link ? (
    <FlatCardListItem className={styles.item} as={Link} to={procedureStatus.link}>
      {children}
    </FlatCardListItem>
  ) : (
    <FlatCardListItem className={styles.item}>{children}</FlatCardListItem>
  )
}

export const MyProcedureStatuses: FC = () => {
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const loading = useSelector((state) => state.procedureStatuses.list.loading)
  const procedureStatuses = useSelector((state) => state.procedureStatuses.list.data)

  useFetchEffect(() => {
    dispatch(
      actionCreators.procedureStatuses.list.fetchData(
        api.createWithAuth(token).procedureStatuses.list({per_page: MAX_COUNT}, ['employee'])
      )
    )
    return () => {
      dispatch(actionCreators.procedureStatuses.list.destroy())
    }
  }, [dispatch, token])

  return (
    <FlatCard>
      <FlatCardHeader border>
        <FlatCardTitle>現在進行中の手続き</FlatCardTitle>
        <SeeMoreButton to={procedureStatuses?.length > 0 ? '/procedure_statuses' : undefined}>すべて見る</SeeMoreButton>
      </FlatCardHeader>
      <FlatCardBody className={styles.cardBody} cramp>
        {!loading &&
          (procedureStatuses.length > 0 ? (
            procedureStatuses.map((procedureStatus) => (
              <ProcedureStatusItem key={procedureStatus.id} procedureStatus={procedureStatus} />
            ))
          ) : (
            <FlatCardListItem className={styles.empty}>進行中の手続きはまだありません</FlatCardListItem>
          ))}
      </FlatCardBody>
    </FlatCard>
  )
}
